export const API = {
	'catalog-websocket': '/api/v1/relay/ws',
};

export const PARTNERS = {
	SNOWFLAKE: 'snowflake',
};

export const I18N_NAME_SPACE = 'tdc-app';

export const TITLE = 'Data Inventory | Talend';

export const PATHS = {
	403: '/403',
	404: '/404',
};

export const FEATURE_FLAGS = {
	DATA_HEALTH_CONSOLE_ENABLED: 'tdc-6311-data-health-console-enabled',
	TDC_6383_TRR_IN_INVENTORY_ENABLED: 'tdc-6383-trr-in-inventory-enabled',
	ADA_CHATBOT_ENABLED: 'prr-701-is-ada-enabled',
};
